<script>
  import { onMount } from 'svelte';

  import {
    addBackgroundImageToLayer,
    deleteElement,
    moveElementUp,
    moveElementDown,
    determineImageUrl,
  } from '../../routes/design/[productSlug]/_design-functions.js';

  import { designState, activeElement, editingElement, designTabActive } from '../../stores/Designer.js';
  import { productDataStore } from '../../stores/ProductData.js';
  import { previewLoading, konvaStageId } from '../../stores/Preview.js';
  import { webPSupport } from '../../stores/WebP.js';

  import LoadingSpinner from '../LoadingSpinner.svelte';
  import FrontBackPreviewToggle from '../Design/FrontBackPreviewToggle.svelte';
  import SelectedProductsPreview from '../Design/SelectedProductsPreview.svelte';
  import determineProductColourImageUrl from '../../utils/determineProductColourImageUrl.js';

  export let segment;
  export let konvaContainerReady;
  export let konvaStage;
  export let stageWidth;
  export let stageHeight;
  export let mainHeight;
  export let mainWidth;
  export let currentTab;
  export let initialSetupComplete = false;

  let mounted = false; // can only do the resize if the container element exists on page

  let ext = 'png';
  if ($webPSupport) {
    ext = 'webp';
  }

  let icons = {
    edit: `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
	<path d="M48.7,6.5c-1.8-1.9-3.6-3.9-5.7-5.5c-2-0.4-2.9,1.7-4.2,2.7c2.3,2.6,4.9,5,7.4,7.5C47.2,9.9,49.9,8.5,48.7,6.5z M47.5,16.5
		c-1.6,1.6-3.2,3.1-4.7,4.7c0,6.2,0,12.5,0,18.7c0,2.3-2,4.3-4.3,4.4c-9.5,0-19,0-28.4,0c-2.6-0.1-4.6-2.5-4.4-5c0-9,0-18.1,0-27.1
		c-0.2-2.5,1.9-4.9,4.4-5c6.3-0.1,12.6,0,18.8,0c1.6-1.5,3.1-3.1,4.7-4.6c-8.4,0-16.7,0-25.1,0C4.6,2.6,1.1,6,1,9.9
		C1,20.5,1,31,1,41.6c0,3.8,3.2,7.1,7,7.4h32.8c3.5-0.6,6.6-3.7,6.6-7.4C47.6,33.2,47.5,24.8,47.5,16.5z M45,12.4
		c-2.5-2.5-4.9-4.9-7.4-7.4c-5.4,5.4-10.9,10.8-16.3,16.2c2.5,2.5,4.9,4.9,7.4,7.4C34.1,23.2,39.6,17.8,45,12.4z M17.2,32.6
		c3.3-0.9,5.1-1.5,8.4-2.4c0.9-0.3,1.5-0.5,1.9-0.6c-2.4-2.2-5.1-5-7.4-7.3C19.2,25.7,18.2,29.1,17.2,32.6z"/>
</svg>`,
    moveUp: `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
<path d="M4.3,1C2.5,1,1,2.5,1,4.3v25.1c0,1.8,1.5,3.3,3.3,3.3h13.1v13.1c0,1.8,1.5,3.3,3.3,3.3h25.1c1.8,0,3.3-1.5,3.3-3.3V20.6
	c0-1.8-1.5-3.3-3.3-3.3H32.6V4.3c0-1.8-1.5-3.3-3.3-3.3H4.3z M4.3,3.2h25.1c0.6,0,1.1,0.5,1.1,1.1v25.1c0,0.6-0.5,1.1-1.1,1.1H4.3
	c-0.6,0-1.1-0.5-1.1-1.1V4.3C3.2,3.7,3.7,3.2,4.3,3.2z"/>
</svg>`,
    moveDown: `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
<path d="M4.3,1C2.5,1,1,2.5,1,4.3v25.1c0,1.8,1.5,3.3,3.3,3.3h13.1v13.1c0,1.8,1.5,3.3,3.3,3.3h25.1c1.8,0,3.3-1.5,3.3-3.3V20.6
	c0-1.8-1.5-3.3-3.3-3.3H32.6V4.3c0-1.8-1.5-3.3-3.3-3.3H4.3z M4.3,3.2h25.1c0.6,0,1.1,0.5,1.1,1.1v13.1h-9.8c-1.8,0-3.3,1.5-3.3,3.3
	v9.8H4.3c-0.6,0-1.1-0.5-1.1-1.1V4.3C3.2,3.7,3.7,3.2,4.3,3.2z"/>
</svg>`,
    delete: `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
<path d="M19.9,1l-2.5,2.5H7.3v5.1h35.4V3.5H32.6L30.1,1H19.9z M9.8,11.1v32.8c0,2.8,2.3,5.1,5.1,5.1h20.2c2.8,0,5.1-2.3,5.1-5.1
	V11.1H9.8z M17.4,18.7h5.1v22.7h-5.1V18.7z M27.5,18.7h5.1v22.7h-5.1V18.7z"/>
</svg>`,
  };

  function changeGender(selection) {
    $productDataStore[$productDataStore.showing].gender = selection;
  }

  // Only show correct side for print steps
  $: if (segment === 'back-print') {
    $productDataStore.side = 'back';
  }
  $: if (segment === 'front-print') {
    $productDataStore.side = 'front';
  }

  // React to store changes
  let productImage;
  $: (async () => {
    productImage = await updateProductImage($productDataStore);
  })(); // Update on change of productDataStore

  // $: productClipPath = updateProductClipPath(konvaStage, $productDataStore); //Update on change of productDataStore

  let frontPreviewUrl;
  let backPreviewUrl;
  $: (async () => {
    frontPreviewUrl = await updatePreviewUrl('front', $productDataStore);
  })();

  $: (async () => {
    backPreviewUrl = await updatePreviewUrl('back', $productDataStore);
  })();

  // mainHeight is bound in layout and calculated on window resize in layout, so if we make reactive here will update whenever window resizes
  $: containerHeight = resize(mainHeight, mainWidth); //pass in mainWidth so resize is triggered on width change as well

  function resize(mainHeight) {
    let containerHeight;
    if (konvaStage && mounted) {
      let container = document.querySelector('#stage-container');
      let containerWidth = container.offsetWidth;
      containerHeight = mainHeight - 140; // 140 is for margins etc

      let scale = 0.9 * (containerWidth / stageWidth);

      let newHeight = stageHeight * scale;

      //If we are still bigger than container height then adjust scale
      if (newHeight > containerHeight) {
        scale = containerHeight / stageHeight;
      } else if (containerHeight >= newHeight) {
        containerHeight = newHeight;
      }

      konvaStage.width(stageWidth * scale);
      konvaStage.height(stageHeight * scale);
      konvaStage.scale({ x: scale, y: scale });
      konvaStage.draw();
    }
    return containerHeight;
  }

  function edit() {
    //show panel on mobile
    $designTabActive = true;

    let elementDetails = designState.getElementDetailsbyId(
      $konvaStageId,
      $productDataStore.showing,
      $productDataStore.side,
      $activeElement,
    );
    $currentTab = elementDetails?.printType ? elementDetails.printType : 'text';
    $editingElement = elementDetails;
  }

  function moveDown() {
    moveElementDown($activeElement, $productDataStore.showing, $productDataStore.side, konvaStage);
  }

  function moveUp() {
    moveElementUp($activeElement, $productDataStore.showing, $productDataStore.side, konvaStage);
  }

  function deleteImg() {
    deleteElement($activeElement, $productDataStore.showing, $productDataStore.side, konvaStage);
    $activeElement = null;
  }

  // If image has loaded already - e.g. after initialisation then we can update src
  async function updateProductImage() {
    let imageUrl = await determineImageUrl({
      side: $productDataStore.side,
      showModel: true,
      size: 512,
      fileType: ext,
      isModelBasedImages: $productDataStore[$productDataStore.showing].isModelBasedImages,
    });

    if (konvaStage && initialSetupComplete && mounted) {
      // We need the stage and productImage to exist
      // Also check mounted for situation when preview is re-mounted after coming back from roster/review step
      // Then productImage is not available until we assign it on mounting
      // No need to update if already match
      if (productImage && productImage.src === imageUrl) {
        return productImage;
      }
      if (!productImage) {
        productImage = addBackgroundImageToLayer(konvaStage, imageUrl, 0, 0);
      } else {
        productImage.src = imageUrl;
      }
      //Can run an onload on image change if we want to save preview images here?
      //   productImage.onload = function () {
    }
    return productImage;
  }

  async function updatePreviewUrl(side) {
    let url = await determineProductColourImageUrl({
      productSlug: $productDataStore[$productDataStore.showing].rootSlug,
      colourPathName: $productDataStore[$productDataStore.showing].selectedColour.pathName,
      colourObject: $productDataStore[$productDataStore.showing].selectedColour,
      imageSize: 128,
      imageType: ext,
      gender: $productDataStore[$productDataStore.showing].gender,
      availableGenders: [
        $productDataStore[$productDataStore.showing].selectedColour.mens ? 'mens' : '',
        $productDataStore[$productDataStore.showing].selectedColour.womens ? 'womens' : '',
        $productDataStore[$productDataStore.showing].selectedColour.youth ? 'youth' : '',
      ],
      side: side,
      showModel: false,
      isModelBasedImages: $productDataStore[$productDataStore.showing].isModelBasedImages,
      sublimationTemplateId:
        $productDataStore[$productDataStore.showing].selectedSublimationTemplate?.SublimationTemplate?.id,
    });
    return url;
  }

  async function initialPreviewSetup() {
    let imageUrl = await determineImageUrl({
      side: $productDataStore.side,
      showModel: true,
      size: 512,
      fileType: ext,
      isModelBasedImages: $productDataStore[$productDataStore.showing].isModelBasedImages,
    });
    productImage = addBackgroundImageToLayer(konvaStage, imageUrl, 0, 0);
    resize(mainHeight);
  }

  // get selected products from design state to show in bottom product toggle region
  let selectedProductsArray;
  $: if ($designState && $konvaStageId) {
    selectedProductsArray = designState.arrayOfSelectedProducts($konvaStageId);
  }

  //Initial setup - backround image
  //Run here as konvaStage is not ready after mounting as the stage is generated in layout
  //let initialSetupComplete = false; //Flag to only run initial setup once
  $: (async () => {
    if (!initialSetupComplete && konvaStage && mounted) {
      // The key difference: now we can await inside this block
      await initialPreviewSetup();

      // Only run once
      initialSetupComplete = true;
      $previewLoading = false;
    }
  })();

  onMount(async () => {
    if (konvaStage) {
      //If we have a stage then we can update the preview
      let container = document.querySelector('#preview-container');
      konvaStage.container(container);
      //Now if we haven't setup layers yet we can do it now
      if (!initialSetupComplete) {
        await initialPreviewSetup();
        initialSetupComplete = true;
        $previewLoading = false;
      } else {
        // We need to get the bg image from the existing stage
        // This state is reached when returning from review or team details page
        let layer = konvaStage.findOne('.img-layer');
        let bgImage = layer.findOne('.background-image');
        productImage = bgImage.image();
        $previewLoading = false;
      }

      // Set side based on segment on remount
      // Only show correct side for print steps
      if (segment === 'back-print') {
        $productDataStore.side = 'back';
      }
      if (segment === 'front-print') {
        $productDataStore.side = 'front';
      }
      await updateProductImage();
      //konvaStage.draw();
      mounted = true;
    } else {
      // Stage is generated in parent _layout component
      // Tell component the DOM is ready for Konva binding
      konvaContainerReady = true;
      mounted = true;
    }
  });
</script>

<div class="container" id="stage-container" style="--containerHeight: {$previewLoading ? 400 : containerHeight}px">
  {#if segment === 'front-print' || segment === 'back-print'}
    {#if $activeElement !== null}
      <div class="edit-container" id="edit-container">
        <div id="edit" class="edit">
          <div class="edit-item" title="edit" on:click={edit}>
            {@html icons.edit}
            <span class="edit-label">Edit</span>
          </div>
          <div class="edit-item" title="move down layer" on:click={moveDown}>
            {@html icons.moveDown}
            <span class="edit-label">Down</span>
          </div>
          <div class="edit-item" title="move up layer" on:click={moveUp}>
            {@html icons.moveUp}
            <span class="edit-label">Up</span>
          </div>
          <div class="edit-item" title="delete" on:click={deleteImg}>
            {@html icons.delete}
            <span class="edit-label">Delete</span>
          </div>
        </div>
      </div>
    {/if}
  {/if}

  <div class="genders">
    {#if $productDataStore[$productDataStore.showing].mensAvailable}
      <span
        class="gender"
        title="show mens"
        class:active={$productDataStore[$productDataStore.showing].gender === 'mens'}
        on:click={() => changeGender('mens')}>M</span
      >
    {/if}
    {#if $productDataStore[$productDataStore.showing].womensAvailable}
      <span
        class="gender"
        title="show womens"
        class:active={$productDataStore[$productDataStore.showing].gender === 'womens'}
        on:click={() => changeGender('womens')}>W</span
      >
    {/if}
    {#if $productDataStore[$productDataStore.showing].youthAvailable}
      <span
        class="gender"
        title="show youth"
        class:active={$productDataStore[$productDataStore.showing].gender === 'youth'}
        on:click={() => changeGender('youth')}>Y</span
      >
    {/if}
  </div>

  {#if segment === 'choose-uniform-items' || segment === 'choose-colours' || segment === 'choose-template'}
    <FrontBackPreviewToggle {frontPreviewUrl} {backPreviewUrl} />
  {/if}

  <div id="preview-container" />
  {#if $previewLoading}
    <div class="loading">
      <LoadingSpinner />
    </div>
  {/if}
</div>

<div class="preview-disclaimer">
  <div class="disclaimer-text">
    <span>
      <strong>Note:</strong>
    </span>
    <span> The preview is approximate. Final printed product may vary slightly. </span>
  </div>
</div>

<SelectedProductsPreview {selectedProductsArray} />

<style>
  #stage-container {
    margin: 2rem;
    margin-top: 4rem;
    margin-bottom: 0.5rem;
    display: flex;
    justify-content: center;
    background-color: #fff;
    box-shadow: 1px 1px 0.5rem rgba(0, 0, 0, 0.15);
    border-radius: 5px;
    position: relative;
    height: var(--containerHeight);
  }

  #preview-container {
    margin-left: auto;
    margin-right: auto;
  }

  .loading {
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    position: absolute;
    background: rgba(255, 255, 255, 0.9);
  }

  .genders {
    left: 0;
    right: 0;
    position: absolute;
    z-index: 10;
    display: flex;
    justify-content: left;
    padding-top: 1rem;
    padding-left: 1rem;
    max-width: 60%;
  }

  .gender.active {
    color: #fe5900;
    border: 1px solid #fe5900;
  }

  .gender {
    cursor: pointer;
    color: #8c8c8c;
    border: 1px solid #ddd;
    height: 2.5rem;
    width: 2.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Oswald', sans-serif;
    margin-right: 0.5rem;
  }

  .edit-container {
    padding: 0.5rem;
    right: 0;
    position: absolute;
    z-index: 15;
  }

  .edit {
    display: flex;
    flex-direction: column;
    background-color: #fff;
    box-shadow: 1px 1px 0.5rem rgba(0, 0, 0, 0.15);
  }

  .edit-item {
    width: 40px;
    padding: 1rem;
    text-align: center;
    cursor: pointer;
    font-size: 0.8rem;
    font-weight: bold;
  }

  .edit-item:hover {
    background-color: rgba(0, 0, 0, 0.15);
  }

  .preview-disclaimer {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    font-size: 1rem;
    text-align: center;
    margin-top: 0.5rem;
    margin-bottom: 1rem;
  }

  .selected-preview-container {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .selected-product {
    display: flex;
    align-items: center;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
    padding: 0.5rem;
    background-color: #fff;
    border-radius: 5px;
    box-shadow: 1px 1px 0.5rem rgba(0, 0, 0, 0.15);
  }

  .selected-product:hover {
    border: 1px solid rgba(0, 0, 0, 0.15);
    cursor: pointer;
  }

  .selected-product .label {
    text-transform: capitalize;
    font-size: 1.2rem;
  }

  .selected-product img {
    max-height: 40px;
  }
</style>
